// =============================================================================
// IIFE entry — built by `npm run build:sdk` (see vite.sdk.config.ts) into
// public/snippets/appbuild-wrapper-sdk.js. Customer pages load it via a
// <script src> tag and access the SDK as `window.AppbuildWrapper`.
//
// In-bundle consumers (e.g. the SDK tester app's module mode, future
// internal code, eventually an npm package) never go through this entry —
// they `import { bridge } from '@/snippets/appbuild-wrapper-sdk'` directly
// from index.ts. This file exists solely to package the SDK for the
// snippet distribution channel.
// =============================================================================

import { bridge } from './index';

declare global {
  interface Window {
    /** Appbuild Wrapper SDK singleton, exposed by the
     *  appbuild-wrapper-sdk snippet. Bundled (in-repo) consumers import
     *  the same instance directly from '@/snippets/appbuild-wrapper-sdk'. */
    AppbuildWrapper?: typeof bridge;
  }
}

// Re-entry guard: if the snippet is somehow loaded twice (network race,
// accidental double-include, etc.), keep the first instance — prevents
// two Bridge instances both processing every message and racing on
// requests. The duplicate's `bridge = new Bridge()` side effect still
// ran at module-init (unavoidable for ESM); the guard just stops the
// global from getting clobbered with the duplicate.
if (typeof window !== 'undefined' && !window.AppbuildWrapper) {
  window.AppbuildWrapper = bridge;
}
